import { SortingDirection } from "enums";
import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import { type GenericFiltersMap } from "../../../../../utils/filterUtils";
import { createFiltersSlice, type FiltersState } from "../../../../Application/slices/createFiltersSlice";
import { type AssessmentFiltersEnum } from "../../types/state";

export interface AssessmentFiltersState extends FiltersState<AssessmentFiltersEnum> {
  search: string;
}

export const initialState: AssessmentFiltersState = {
  filterOptions: {} as GenericFiltersMap<AssessmentFiltersEnum>,
  appliedFilter: {} as GenericFiltersMap<AssessmentFiltersEnum>,
  isLoading: false,
  search: "",
  sortingColumnName: "Added",
  sortingDirection: SortingDirection.Descending,
  shouldSort: true,
};

const assessmentFiltersSlice = createFiltersSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.Assessments,
    name: "overviewFilters",
  },
  initialState,
  reducers: {},
});

export const {
  setAppliedFilter,
  resetAppliedFilter,
  setIsLoading,
  setError,
  setFilterOptions,
  resetSearch,
  setSearch,
  setShouldSort,
  resetShouldSort,
  setSortingColumnName,
  setSortingDirection,
  resetSortingColumnName,
  resetSortingDirection,
} = assessmentFiltersSlice.actions;

export default assessmentFiltersSlice.reducer;
